<template>
  <metainfo></metainfo>
  <template v-if="isForbiddenPage()">
    <NoPermission />
  </template>
  <template v-else>
    <div class="container-xl">
      <div class="page-header d-print-none">
        <div class="row g-2 align-items-center">
          <div class="mt-2">
            <template v-if="isPageTelegram()">
              <CountCommentModeration :payload="{
                channel_id: getChannelTelegram(),
                type_visible: 2,
                title: 'Промодерировать в первую очередь',
              }"/>
              <CountCommentModeration :payload="{
                channel_id: getChannelTelegram(),
                type_visible: 1,
                title: 'Промодерировать во вторую очередь',
                level: 'muted'
              }"/>
            </template>
            <template v-if="isPageSite()">
              <CountCommentModeration :payload="{
                channel_id: getChannelSite(),
                type_visible: 2,
                title: 'Промодерировать в первую очередь',
              }"/>
              <CountCommentModeration :payload="{
                channel_id: getChannelSite(),
                type_visible: 1,
                title: 'Промодерировать во вторую очередь',
                level: 'muted'
              }"/>
            </template>
          </div>
          <div class="col-sm">
            <h2 class="page-title">
              <Title :data="{
                title: params.h1,
                page: params.page,
              }"/>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="container-xl">
        <div class="mb-3">
          <CommentFilter @onFilter="onFilter" :payload="filter.payload"/>
        </div>
        <template v-if="isPageTelegram()">
          <div class="mb-3">
            <TelegramCommentModeration :payload="query"/>
          </div>
        </template>
        <template v-if="isPageSite()">
          <div class="mb-3">
            <SiteCommentModeration :payload="query"/>
          </div>
        </template>
      </div>
    </div>
  </template>
</template>

<script>
import TelegramCommentModeration from "@/components/comment_moderation/TelegramCommentModeration"
import SiteCommentModeration from "@/components/comment_moderation/SiteCommentModeration"
import CommentFilter from "@/modules/comments/components/filter/Filter.vue"
import Helper from "@/services/Helper"
import {onMounted, reactive, ref} from "vue"
import {useMeta} from "vue-meta"
import NoPermission from "@/modules/auth/pages/no_permission/Index.vue"
import Permission from "@/modules/users/services/Permission"
import {
  commentsCode,
} from "@/modules/auth/services/permissions"
import CountCommentModeration from "@/components/count_comment_moderation/Index"
import {useRoute} from "vue-router"
import Title from "./components/title/Index"

export default {
  name: "Comments",
  components: {
    CountCommentModeration,
    TelegramCommentModeration,
    SiteCommentModeration,
    CommentFilter,
    NoPermission,
    Title,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const route = useRoute()
    useMeta({title: props.params.title})

    let query = ref({})
    let noPermission = ref(false)
    let channels = props.params.channels
    let type_visibility = null

    let filter = reactive({
      payload: {
        search: "",
        date: null,
        users: [],
        channels: channels,
        type_visibility: type_visibility,
      },
    })

    onMounted(() => {
      if (!checkPermission()) {
        return
      }

      let params = getFilter()
      
      if (params.channelId) {
        filter.payload.channels = params.channelId
      }
      
      filter.payload.type_visibility = params.typeVisible
    })

    function getFilter() {
      let channelId
      let typeVisible = route.query.type_visible

      if (route.query.channel_id) {
        if (Helper.isArray(route.query.channel_id)) {
          channelId = route.query.channel_id
        } else {
          channelId = [route.query.channel_id]
        }
      }

      return {
        channelId,
        typeVisible,
      }
    }

    function checkPermission() {
      if (!Permission.hasPermissions(commentsCode)) {
        setNoPermission()
        return false
      }

      return true
    }

    function setNoPermission() {
      noPermission.value = true
    }

    function isForbiddenPage() {
      return noPermission.value
    }

    function onFilter(payload) {
      payload = Helper.mergeObject(payload, {
        categories: ['all', 'new', 'approved', 'rejected', 'removed'],
        limit: 50,
        active_category: 'new',
        force_show: true,
        filter: {
          user_ids: payload.users ?? [],
          channels: payload.channels ?? [],
          from_date: payload.date?.from ?? "",
          to_date: payload.date?.to ?? "",
          query_string: payload.search ?? "",
          type_visibility: payload.type_visibility ?? null,
        },
      })

      payload = Helper.clone(payload)

      query.value = payload
    }

    function getChannelTelegram() {
      return [2, 3, 4, 5, 7, 8, 9, 10, 11, 12]
    }

    function getChannelSite() {
      return [1]
    }

    function getPage() {
      return props.params.page;
    }

    function isPageTelegram() {
      return getPage() === "telegram_comments"
    }

    function isPageSite() {
      return getPage() === "site_comments"
    }

    return {
      onFilter,
      filter,
      query,
      isForbiddenPage,
      getChannelTelegram,
      getChannelSite,
      isPageTelegram,
      isPageSite,
    }
  },
}
</script>

<style scoped>

</style>
